<div style="margin: 10px 10px 10px 0px;">
  <h1>Windows</h1>
  <form [formGroup]="SettingsForm" (ngSubmit)="applyTempChanges()">
    <div class="mb-3 row">
      <label for="name" class="col-lg-2 col-form-label">Name:</label>
      <div class="col-lg-4">
        <input id="name" type="text" class="form-control" [ngClass]="{'is-invalid':!Name.valid}" [formControl]="Name" />
      </div>
      <div class="col-lg-2">
        <input type="checkbox" [formControl]="IsDefault" [ngClass]="{'is-invalid': !IsDefault.valid}" />
        <span class="uv-checkbox-label">Default</span>
      </div>
    </div>
    @if (Name.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-6 alert alert-danger error-message">Name is required</div>
      </div>
    }
    <div class="mb-3 row">
      <label for="username" class="col-lg-2 col-form-label">User Name:</label>
      <div class="col-lg-4">
        <input id="username" type="text" class="form-control" [ngClass]="{'is-invalid':!Username.valid}" [formControl]="Username" />
      </div>
    </div>
    @if (Username.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-6 alert alert-danger error-message">User Name is required</div>
      </div>
    }
    <div class="mb-3 row">
      <label for="password" class="col-lg-2 col-form-label">Password:</label>
      <div class="col-lg-4">
        <input id="password" [type]="PasswordInputType" class="form-control"
          [ngClass]="{'is-invalid':SettingsForm.hasError('passwordsEqual')}" [formControl]="Password"
          (keydown)="onPasswordKeyDownHandler($event, 'Password')" />
        </div>
      </div>
      <div class="mb-3 row">
        <label for="confirmPassword" class="col-lg-2 col-form-label">Confirm Password:</label>
        <div class="col-lg-4">
          <input id="confirmPassword" [type]="PasswordInputType" class="form-control"
            [ngClass]="{'is-invalid':SettingsForm.hasError('passwordsEqual')}" [formControl]="PasswordConfirm"
            (keydown)="onPasswordKeyDownHandler($event, 'Password')" />
          </div>
        </div>
        @if (SettingsForm.hasError('passwordsEqual')) {
          <div class="mb-3 row">
            <div class="col-lg-6 alert alert-danger error-message">Confirm Password must be the same as Password</div>
          </div>
        }
        <div class="mb-3 row">
          <span class="col-lg-2 col-form-label">&nbsp;</span>
          <div class="col-lg-10">
            <input type="checkbox" [formControl]="ShowChars"
              (change)="ToggleShowChars()" [ngClass]="{'is-invalid':!ShowChars.valid}" />
              <span class="uv-checkbox-label">Show Chars</span>
            </div>
          </div>
          <div class="mb-3 row">
            <span class="col-lg-2 col-form-label">&nbsp;</span>
            <div class="col-lg-10">
              <input type="checkbox" [formControl]="UsePowerShell" [ngClass]="{'is-invalid':!IpScope.valid}" />
              <span class="uv-checkbox-label">Use PowerShell</span>
            </div>
          </div>
          <div class="mb-3 row">
            <label for="ipscope" class="col-lg-2 col-form-label">IP Scope:</label>
            <div class="col-lg-4">
              <textarea id="ipscope" rows="5" cols="50" class="form-control" [formControl]="IpScope"
              [ngClass]="{'is-invalid': !IpScope.valid}"></textarea>
            </div>
          </div>
          <div style="margin-top: 20px;">
            <button type="submit" pButton [disabled]="!SettingsForm.valid || SettingsForm.pristine" label="Apply"></button>
          </div>
        </form>
      </div>
